<template>
    <div v-if="config.display" v-show="!config.hideControl" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <div v-if="!optionsReady" class="loading-message">
                Getting data. Please wait...
            </div>
            <div v-else :class="{'flex' : config.showSecondaryActionsSeparately}">
                <div class="sub-content-area">
                    <div class="message-container" v-if="config.message">
                        <p class="input-info" v-html="ddStoreFilter(config.message)"></p>
                    </div>
                    <div class="secondary-action-container" v-if="config.secondaryActions">
                        <div v-if="config.showSecondaryActionsSeparately">
                            <div v-for="(item, index) in config.secondaryActions" :key="index" class="separately-secondary-action-button-wrapper">
                                <control :name="this.id + 'SECONDATY_ACTION_' + index" :prop-config="{
                                    disabled: config.disabled,
                                    label: item.text,
                                    type: 'button',
                                    logic: item.logic
                                }"
                                         v-on:click="runSecondaryAction($event, index)"
                                ></control>
                            </div>
                        </div>
                        <div v-else>
                            <ejs-splitbutton
                                :disabled="config.disabled"
                                :content="config.secondaryActions[0].text"
                                :items="config.secondaryActions.slice(1)"
                                v-on:click="runSecondaryAction($event)"
                                v-on:select="runSecondaryAction($event)"
                                class="secondary-action-button"
                            ></ejs-splitbutton>
                        </div>
                    </div>
                </div>
                <div class="grid-wrapper">
                    <grid
                        :c-id="'grid__control_' + (config.ref || config.id)"
                        ref="config.ref || config.id"
                        :prop-data="gridData"
                        :prop-settings="config.gridSettings"
                        :prop-selected-items="selectedItems"
                        @update:prop-selected-items="selectedItems = $event;"
                        :prop-selected-items-full-data="selectedItemsFullData"
                        @update:prop-selected-items-full-data="selectedItemsFullData = $event; disableButtons()"
                        :prop-row-selecting-func="selectingFnc"
                    ></grid>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";
import { library } from "@common/library/library";

export const gridComponent = {
    mixins: [controlMixins],
    data() {
        return {
            selectedItemsFullData: []
        };
    },
    computed: {
        selectedItems: {
            get() {
                return this.value;
            },
            set(value) {
                this.value = value;
            }
        },
        gridData() {
            let gridData = {
                headers: [],
                records: []
            };
            if (this.config && this.config.tableHeaders) {
                gridData.headers = this.config.tableHeaders;
                if (this.options && this.options.length) {
                    for (let i in this.options) {
                        if (i === 'length') continue;
                        let tmp = library.cloneObj(this.options[i]);
                        tmp['rowID'] = tmp[this.config.gridSettings.rowIDColumn] || parseInt(i, 10);
                        gridData.records.push(tmp);
                    }
                }
            }
            return gridData;
        }
    },
    methods: {
        disableButtons() {},
        selectingFnc() {},
    },
    components: {
        'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
        'ejs-splitbutton': defineAsyncComponent(() => import('@common/syncfusion/splitButton')),
        'control': defineAsyncComponent(() => import('@common/control/control.vue')),
    }
};

export default gridComponent;
</script>
<style scoped>
.sub-content-area {
    display: flex;
}
.sub-content-area > div {
    margin: 0 10px;
    position: relative;
    top: -4px;
}
.sub-content-area > div + div {
    margin-left: 0;
}
.sub-content-area > div.message-container {
    flex-grow: 9;
}
.secondary-action-button {
    text-decoration: underline;
    color: #0B4A97;
    padding: 5px 8px;
    background: #eee;
    font-size: 14px;
    border-radius: 0 0 6px 6px;
    white-space: nowrap;
}
:deep(.flex)  {
    width: 100%;
    display: flex;
}
:deep(.flex .grid-wrapper) {
    flex-grow: 12;
}
:deep(.flex .separately-secondary-action-button-wrapper) {
    margin: 0 5px;
}
:deep(.e-columnheader  *) {
    background-color: #607D8B !important;
    color: #fff;
}
:deep(.e-columnheader .e-frame) {
    color: #fff !important;
    border-color: #fff !important;
}
:deep(.e-gridcontent .e-checkbox-wrapper .e-frame) {
    margin-left: 9px;
}
</style>
